export default "__VITE_ASSET__6658ba02__"